// eslint-disable-next-line no-shadow
export var BusinessNotifications;
(function (BusinessNotifications) {
    BusinessNotifications["DeliveryClosing"] = "deliveryclosing";
    BusinessNotifications["PickupClosing"] = "pickupclosing";
    BusinessNotifications["RestaurantClosed"] = "restaurantclosed";
    BusinessNotifications["OnlyFutureOrders"] = "onlyFutureOrders";
    BusinessNotifications["OlOunavailable"] = "olounavailable";
    BusinessNotifications["CantAcceptOrders"] = "cantAcceptOrders";
    BusinessNotifications["NotPremium"] = "notpremium";
    BusinessNotifications["NoPaymentMethods"] = "nopaymentmethods";
    BusinessNotifications["NoPhysicalLocation"] = "nophysicallocation";
})(BusinessNotifications || (BusinessNotifications = {}));
//# sourceMappingURL=BusinessNotifications.js.map